import axios from "axios";
import { useMutation} from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

const saveScript = async ({ endpointId, testCaseId, preRequest, postResponse }) => {
  const user = getUserDetails();
  
  const queryParams = new URLSearchParams({
    companyId: user.companyid,
  });

  if (endpointId) {
    queryParams.append('endpointId', endpointId);
  }
  if (testCaseId) {
    queryParams.append('testCaseId', testCaseId);
  }

  const response = await axios.put(
    `${API_BACKEND_URL}/updateScript`,
    {
      endpointId: endpointId || null,
      testCaseId: testCaseId || null,
      preRequest: preRequest || null,
      postResponse: postResponse || null,
    },
  );

  return response.data;
};

export const useApiScripts = (options = {}) => {


  return useMutation({
    mutationFn: saveScript,
    ...options,
  });
};
